import React, { Component } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
// import Navbar from "../Navbar";
// import service from "../../utils/service";
import "primeflex/primeflex.css";
import { Dropdown } from "primereact/dropdown";

import "../../style/news.css";

class Advertising extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayAdvForm: false,
      
      region: "Europe",
     advURL: "",
    };
    
    this.toggleDisplay = this.toggleDisplay.bind(this);
    // this.uploadAdBanner = this.uploadAdBanner.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }


  toggleDisplay(val) {
    this.setState((prevState) => {
      return {
        [val]: !prevState[val],
      };
    });
  }

  // uploadAdBanner() {
  //   let file = this.fileInput;
  //   let region = this.state.region;
  //   let redirectUrl = this.state.advURL;
  //   let renamedFile = new window.File(
  //     [file],
  //     this.generateFileName(file, region),
  //     {
  //       type: "image/png",
  //       lastModified: Date.now(),
  //     }
  //   );
  //   service.postImageToS3(renamedFile).then((res, rej) => {});
  //   let imgUrl =
  //     "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/" +
  //     renamedFile.name;
  //   let data = {
  //     imageUrl: imgUrl,
  //     redirectUrl: redirectUrl,
  //     region: region,
  //   };
  //   service.sendAdDetails(region, data);
  //   this.setState({
  //     region: "Europe",
  //     advURL: "",
  //   });
  // }

  handleChange(name, event) {
    this.setState({
      [name]: event.target.value,
    });
  }


  render() {
    const regions = [
        { label: "North America", value: "North America" },
        { label: "Europe", value: "Europe" },
        { label: "Latin America", value: "Latin America" },
      ];
    return (
      <div className="main-box">
        
        <Button
                onClick={() => this.toggleDisplay("displayAdvForm")}
                label="Add Advertisement"
                className="btn3 news-btn"
              />
              {this.state.displayAdvForm && (
                <div className="form-box clear" style={{ width: "50%" }}>
                  <p className="head-form">Add Advertisement</p>
                  <div className="p-fluid">
                    <div className="field">
                      <label>
                        Select image for upload
                        <input type="file" ref={this.fileInput} />
                      </label>
                      <br />
                    </div>
                    <div>
                      <label htmlFor="region">Select region</label>
                      <Dropdown
                        className="p-dropdown"
                        id="region"
                        value={this.state.region}
                        options={regions}
                        onChange={(event) => {
                          this.handleChange("region", event);
                        }}
                      />
                    </div>
                    <div className="field">
                      <label htmlFor="advURL">Enter redirect URL</label>
                      <InputText
                        id="advURL"
                        value={this.state.advURL}
                        type="text"
                        onChange={(event) => {
                          this.handleChange("advURL", event);
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <Button
                      onClick={() => this.toggleDisplay("displayAdvForm")}
                      label="Close"
                      className="p-button-sm btn3"
                    />
                    <Button
                      onClick={() => this.toggleDisplay("displayAdvForm")}
                      label="Upload"
                      className="p-button-sm btn3"
                    />
                    <div className="clear"></div>
                  </div>
                </div>
              )}
      </div>
    );
  }
}


export default Advertising;
